'use strict';
(function ($, Drupal) {
    Drupal.behaviors['cplBaseCommerceAccount'] = {
        attach: function (context, settings) {
            let $profileListing = $('.profile-type-listing', context);
            let $addProfileButton = $('.add-new-address', context);
            let $addProfileForm = $('.profile-customer-add-form', context);
            let closeBtnMarkup = '<button class="close-button" aria-label="Close form" type="button">\xD7</button>';
            // Equalize address book items, open offcanvas form.
            $profileListing.once('profile-listing').each(function () {
                let $this = $(this);
                $this.find('.views-row').attr('data-equalizer-watch', 'equalize-profiles');
                $this.attr({
                    'data-equalizer': 'equalize-profiles',
                    'data-equalize-on': 'small'
                });
                $addProfileForm.prepend(closeBtnMarkup);
                $addProfileForm.find('.close-button').click(function () {
                    $addProfileForm.removeClass('is-active');
                });
                $addProfileButton.addClass('medium-6 large-4 columns views-row').attr('data-equalizer-watch', 'equalize-profiles').remove().clone().appendTo($this);
                $this.find('.add-new-address').click(function (e) {
                    e.preventDefault();
                    $addProfileForm.toggleClass('is-active');
                });
                $this.foundation();
            });
            // Equalize paymen method items.
            let $paymentListing = $('.payment-method-listing', context);
            $paymentListing.once('payment-listing').each(function () {
                let $this = $(this);
                $this.find('.views-row').attr('data-equalizer-watch', 'equalize-payment');
                $this.attr({
                    'data-equalizer': 'equalize-payment',
                    'data-equalize-on': 'small'
                });
                $this.foundation();
            });
            // Equalize favorite products view.
            let $favoriteProducts = $('.favorite-products-view', context);
            $favoriteProducts.once('favorite-products').each(function () {
                let $this = $(this);
                $this.find('.views-row').attr('data-equalizer-watch', 'equalize-favorites');
                $this.attr({
                    'data-equalizer': 'equalize-favorites',
                    'data-equalize-on': 'small'
                });
                $this.foundation();
            });
            // Add attributes to logout link to open popup window.
            let $logout = $('.user-logout', context);
            $logout.once('account-logout-link').each(function () {
                $(this).attr('data-open', 'account-logout').on('click', function (e) {
                    // Prevent default click handler as Zurb's toggler handles it.
                    e.preventDefault();
                });
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceCart'] = {
        attach: function (context, settings) {
            const $cartButton = $('.menu-link-item-cart a, .cart-popup-trigger', context);
            $cartButton.once('cart-button').each((index, el) => {
                $(el).attr({ 'data-toggle': 'right-off-canvas-menu' }).on('click', e => {
                    // Prevent default click handler as Zurb's toggler handles it.
                    e.preventDefault();
                });
            });
            // Badge with quantity of items in cart.
            const $blockPopup = $('.block-cart-popup', context);
            $blockPopup.once('cart-popup-block').each((index, element) => {
                const $items = $(element).find('.views-field-nothing .cart-item').length;
                if ($items) {
                    const waitRender = (selector, callback) => {
                        if ($(selector).length) {
                            callback();
                        } else {
                            setTimeout(() => waitRender(selector, callback), 100);
                        }
                    };
                    waitRender('.header-nav-commerce .menu-link-item-cart a', () => {
                        // Add badge to header icon and to mobile menu icon.
                        let quantity = 0;
                        if (!$('.js-cart-items').length) {
                            $('.header-nav-commerce .menu-link-item-cart a, .cpl-menu-type-7 .menu-icon-cart').append('<span class="js-cart-items badge alert"></span>');
                        }
                        $('.block-cart-popup div[class*="form-item-edit-quantity-"]').each((ind, el) => {
                            const value = $(el).find('.form-number').val();
                            quantity += Number(value);
                        });
                        if (quantity > 0) {
                            $('.js-cart-items').text(quantity);
                        }
                    });
                } else {
                    $('.js-cart-items').remove();
                }
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceCheckout'] = {
        attach: function (context, settings) {
            const $checkoutForm = $('.checkout-form', context);
            $checkoutForm.once('form-checkout').each((index, el) => {
                const $this = $(el);
                // Hide/show summary on mobile.
                const $summaryShow = $this.find('.summary-title-show');
                const $summaryHide = $this.find('.summary-title-hide');
                const $summaryMobile = $this.find('.checkout-summary-sm');
                const $summaryContent = $this.find('.checkout-summary-content');
                $summaryMobile.click(event => {
                    event.preventDefault();
                    if (!$summaryContent.is(':visible')) {
                        $summaryContent.show();
                        $checkoutForm.addClass('is-open');
                        $summaryShow.hide();
                        $summaryHide.show();
                    } else {
                        $summaryContent.hide();
                        $checkoutForm.removeClass('is-open');
                        $summaryShow.show();
                        $summaryHide.hide();
                    }
                });
                // Total amount.
                const total = $this.find('.order-total-line__total .order-total-line-value').text();
                $this.find('.checkout-summary-sm-price').text(total);
                function calculateSidebarHeight() {
                    const $sidebarInner = $this.find('.checkout-summary-content-inner');
                    $sidebarInner.css('height', '');
                    const $sidebarPrice = $this.find('.field-name-total-price');
                    $sidebarInner.css('height', $sidebarInner.height() + $sidebarPrice.height());
                }
                // Set items height for long checkout forms.
                calculateSidebarHeight();
                $(document).ajaxComplete(() => calculateSidebarHeight());
            });
            // Postal code input format.
            const notAlphaNumeric = /[^a-zA-Z0-9]/g;
            $('input.postal-code', context).once('zip-code-input').each(function () {
                const $this = $(this);
                $this.on('keyup change', () => {
                    const value = $this.val();
                    const cleanValue = value.replace(notAlphaNumeric, '');
                    if (value !== cleanValue) {
                        $this.val(cleanValue);
                    }
                });
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceFacetAccordion'] = {
        attach: function (context, settings) {
            let $accordion = $('.facet-accordion', context);
            $accordion.once('profile-listing').each(function () {
                let $this = $(this);
                if ($this.find('.accordion-content .facet-empty').length) {
                    $this.hide();
                } else {
                    $this.show();
                }
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceFiveStars'] = {
        attach: function (context, settings) {
            const $reviewsSummary = $('.product-reviews-summary', context);
            $reviewsSummary.once('review-summary').each((index, el) => {
                const $this = $(el);
                const $stars = $this.find('.stars');
                const averageVote = $stars.data('vote-average');
                // Round the average number for data-vote-average-rounded attribute.
                const isFloat = n => n === +n && n !== (n | 0);
                const averageVoteRounded = isFloat(averageVote) ? parseFloat(averageVote).toFixed(1) : parseInt(averageVote, 10);
                // Uses in css to display the average number.
                $stars.attr('data-vote-average-rounded', averageVoteRounded);
                function populateStars(stars, score) {
                    const wholeStars = Math.floor(score);
                    const halfStar = wholeStars < score;
                    for (var star = 1; star <= wholeStars; star++) {
                        $this.find(`.star-${ star }`, stars).addClass('full');
                    }
                    if (halfStar) {
                        $this.find(`.star-${ star }`, stars).addClass('half');
                    }
                }
                populateStars($this, averageVote);
            });
            // Transform Vote select field into 5 stars widget.
            const $voteField = $('[id^=edit-field-review-vote].form-select', context);
            $voteField.once('vote-field-transform').each((index, el) => {
                const $this = $(el);
                if (!$('.five-star-error').length) {
                    $this.after(`<div class="five-star-error" hidden>
        ${ Drupal.t('Please select vote rating.') }
      </div>`);
                }
                // Init 5 stars script.
                $this.barrating({ theme: 'fontawesome-stars' });
                // Display error if all stars are empty.
                $('#comment-form').on('submit', event => {
                    if ($this.val() === '_none') {
                        event.preventDefault();
                        const $errorMessage = $('.five-star-error');
                        $errorMessage.slideDown();
                    }
                });
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceFloatLabels'] = {
        attach: function (context, settings) {
            const $checkoutFormInputs = $('.form-item', context).filter(function () {
                return !!$(this).parents('.checkout-form').length;
            });
            $checkoutFormInputs.once('floating-label-checkout').each((index, el) => {
                const labels = new FloatLabels($(el)[0], {
                    prefix: 'fl-',
                    prioritize: 'label',
                    transform: 'input, textarea'
                });
            });
            // Account inputs
            const $accountInputs = $('.form-item', context).filter(function () {
                return !!$(this).parents('.profile-customer-add-form, .dcom-user-account-form, .dcom-user-business-form, .account-order-return').length;
            });
            $accountInputs.once('floating-label-account').each((index, el) => {
                const labels = new FloatLabels($(el)[0], {
                    prefix: 'fl-',
                    prioritize: 'label',
                    transform: 'input'
                });
            });
            // Tel fields with inputmask
            const $telField = $('.js-form-type-tel', context);
            $telField.once('telephone-field').each((index, el) => {
                const $this = $(el);
                const $input = $this.find('.form-tel');
                $input.on('keyup blur focus', () => {
                    if ($input.val() || $input.is(':focus') || $input.is(':-webkit-autofill')) {
                        $this.find('.fl-wrap').addClass('fl-is-active');
                    } else {
                        $this.find('.fl-wrap').removeClass('fl-is-active');
                    }
                });
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceMegamenu'] = {
        attach: function (context, settings) {
            const $megamenu = $('.mega-menu-wrapper', context);
            $megamenu.once('megamenu-class-slideshow').each(function () {
                const $this = $(this);
                // Finds megamenu and adds class to parent menu item.
                const $parentLink = $this.parent('.menu-item');
                $parentLink.addClass('is-megamenu');
                // Collections slideshow.
                const $slideshowContainer = $this.find('.simple-mega-menu');
                const $slideshowWrapper = $this.find('.field-name-field-megamenu-item > .field-items');
                if ($slideshowContainer.hasClass('simple-mega-menu-1')) {
                    $parentLink.addClass('megamenu-type-1');
                } else if ($slideshowContainer.hasClass('simple-mega-menu-2')) {
                    $parentLink.addClass('megamenu-type-2');
                }
                if ($slideshowContainer.hasClass('cpl-mega-menu-slideshow')) {
                    const megamenuStyle = $slideshowContainer.attr('data-megamenu-style');
                    let slides;
                    // TODO: slideshow will also be used in style 2 with different settings
                    if (megamenuStyle === 2) {
                        slides = 4;
                    } else if (megamenuStyle === 3) {
                        slides = 4;
                    } else if (megamenuStyle === 4) {
                        slides = 5;
                    }
                    const options = {
                        infinite: true,
                        autoplay: false,
                        slidesToShow: slides,
                        slidesToScroll: slides,
                        dots: true,
                        arrows: false
                    };
                    $slideshowWrapper.slick(options);
                }
            });
            // Menu that opens on click
            const $clickMenu = $('.cpl-mega-menu-click', context);
            $clickMenu.once('click-menu').each(function () {
                const $this = $(this);
                // Finds megamenu and adds class to parent menu item.
                $this.parents('.menu-item').addClass('is-clickable-megamenu');
                // Close the menu.
                $this.find('.close-button').click(event => {
                    event.preventDefault();
                    $('.is-clickable-megamenu').removeClass('is-opened');
                });
            });
            // Open the menu.
            const $clickOpenMenu = $('.is-clickable-megamenu > a', context);
            $clickOpenMenu.once('click-open-menu').each(function () {
                const $this = $(this);
                $this.click(function (event) {
                    event.preventDefault();
                    const $parentMenu = $(this).parent();
                    if (!$parentMenu.hasClass('is-opened')) {
                        $('.is-clickable-megamenu').removeClass('is-opened');
                        $parentMenu.addClass('is-opened');
                    } else {
                        $('.is-clickable-megamenu').removeClass('is-opened');
                    }
                });
            });
            // Ad slideshow for Megamenu Style 2
            const $adSlideshow = $('.megamenu-slideshow-block', context);
            $adSlideshow.once('megamenu-ad-slideshow').each(function () {
                $(this).find('.field-name-field-menu-content-ref > .field-items').slick({
                    infinite: true,
                    autoplay: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                });
            });
            // Vertical tabs for megamenu type 2, style 2.
            const $verticalTabs = $('.cpl-mega-menu-style-2 .paragraph--type--megamenu-menu > .menu', context);
            $verticalTabs.once('megamenu-vertical-tabs').each(function () {
                const $menu = $(this);
                const random = btoa(Math.random()).substr(5, 5).toLowerCase();
                // Tabs content
                $menu.find('li > ul').each(function (index, el) {
                    const $tabContent = $(el);
                    if (index === 0) {
                        $tabContent.addClass('is-tab-active');
                    }
                    $tabContent.attr('id', `tab-${ index }-${ random }`).addClass('tab-content');
                    $tabContent.prepend('<div class="title"></div>');
                });
                // Tabs content items
                $menu.find('li > ul > li').each(function (index, el) {
                    const $tabContentItem = $(el);
                    $tabContentItem.find('a').each(function () {
                        const description = $(this).attr('title');
                        if (description) {
                            $(this).append('<div class="description"></div>');
                            $tabContentItem.find('.description').prepend(description);
                        }
                    });
                });
                // Tabs headers
                $menu.find('> li > a').each(function (index, el) {
                    const $tabHeader = $(el);
                    const title = $tabHeader.text();
                    if (index === 0) {
                        $tabHeader.addClass('is-tab-active');
                    }
                    if ($tabHeader.next('ul').length) {
                        $tabHeader.attr('data-tab-open', `tab-${ index }-${ random }`).addClass('tab-header');
                        $(`#tab-${ index }-${ random } .title`).text(title);
                    }
                    $tabHeader.click(function (event) {
                        event.preventDefault();
                        const id = $(this).attr('data-tab-open');
                        if (id !== undefined) {
                            // Adds active class to tab content.
                            $menu.find('.tab-content').removeClass('is-tab-active');
                            $(`#${ id }`).addClass('is-tab-active');
                            // Adds active class to tab header.
                            $menu.find('> li > a').removeClass('is-tab-active');
                            $tabHeader.addClass('is-tab-active');
                        }
                    });
                });
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceProductPage'] = {
        attach: function (context, settings) {
            const $productGallery = $('.product-image .product-gallery', context);
            $productGallery.once('product-page-gallery').each((index, el) => {
                const $this = $(el);
                const galleryLength = $this.find('.product-gallery-image').length;
                const setGalleryWidth = () => {
                    if (galleryLength < 4 || $(window).width() < 1024) {
                        $this.removeAttr('style');
                        return;
                    }
                    const imageHeight = $this.find('.product-gallery-image').eq(0).height();
                    $this.css('width', imageHeight);
                };
                setGalleryWidth();
                $(window).resize(setGalleryWidth);
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceProductTeaserSlideshow'] = {
        attach: function (context, settings) {
            let $productTeasers = $('.view-shop-products .product-teaser', context);
            $productTeasers.once('product-teaser-slideshow').each(function () {
                let $this = $(this);
                let $slideshow = $this.find('.field-name-field-product-image .field-items');
                let slides = $slideshow.find('.field-item').length;
                let timer;
                let setImageContainerSize = function () {
                    if (slides > 1) {
                        $slideshow.addClass('is-slideshow');
                        // We have squared product images.
                        $slideshow.css({ height: $this.find('.content-box').width() });
                    }
                };
                if (slides > 1) {
                    setImageContainerSize();
                    $slideshow.find('.field-item:first-child').addClass('field-item-first');
                    // TODO: hover event doesn't work when Slick is enabled.
                    $slideshow.hover(function () {
                        clearInterval(timer);
                        timer = setInterval(function () {
                            $slideshow.find('.field-item:first-child').fadeOut(100).next('.field-item').fadeIn(100).end().appendTo($slideshow);
                        }, 800);
                    }, function () {
                        clearInterval(timer);
                    });
                    $slideshow.mouseleave(function () {
                        $slideshow.find('.field-item').fadeOut(100);
                        $slideshow.find('.field-item-first').fadeIn(100);
                    });
                }
                $(window).resize(setImageContainerSize);
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceQuantityField'] = {
        attach: function (context, settings) {
            const markup = '<div class="quantity-button quantity-down">\u2013</div>' + '<div class="quantity-button quantity-up">+</div>';
            // TODO: make this work only for .cart and .product
            let $quantity = $('.js-form-type-number', context);
            $quantity.once('quantity-field').each(function () {
                let $this = $(this);
                $this.append(markup);
                let $input = $this.find('input[type="number"]');
                let $btnUp = $this.find('.quantity-up');
                let $btnDown = $this.find('.quantity-down');
                let min = $input.attr('min');
                let max = $input.attr('max');
                $btnUp.on('click', function () {
                    var oldValue = parseFloat($input.val());
                    if (oldValue >= max) {
                        var newVal = oldValue;
                    } else {
                        var newVal = oldValue + 1;
                    }
                    $this.find('input').val(newVal);
                    $this.find('input').trigger('change');
                });
                $btnDown.on('click', function () {
                    var oldValue = parseFloat($input.val());
                    if (oldValue <= min) {
                        var newVal = oldValue;
                    } else {
                        var newVal = oldValue - 1;
                    }
                    $this.find('input').val(newVal);
                    $this.find('input').trigger('change');
                });
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceReviews'] = {
        attach: function (context, settings) {
            let $reviewReference = $('.views-comments-ref', context);
            $reviewReference.once('review-reference').each(function () {
                let $this = $(this);
                // Equalize reviews items
                $this.find('.views-row').attr('data-equalizer-watch', 'equalize-reviews-ref');
                $this.attr({
                    'data-equalizer': 'equalize-reviews-ref',
                    'data-equalize-on': 'small'
                });
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceShopEqualizer'] = {
        attach: function (context, settings) {
            let $collections = $('.collection-listing', context);
            $collections.once('collection-listing-equalize').each(function () {
                let $this = $(this);
                $this.find('.views-row').attr('data-equalizer-watch', 'equalize-collections');
                $this.attr({
                    'data-equalizer': 'equalize-collections',
                    'data-equalize-on': 'small'
                });
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceShopFilter'] = {
        attach: function (context, settings) {
            let $sidebar = $('.sidebar-inner', context);
            let $body = $('body', context);
            $sidebar.once('search-filter').each(function () {
                let $this = $(this);
                let $resetButton = $this.find('.reset-filter');
                // Floating labels on expose search form.
                $this.find('.bef-exposed-form form').each(function () {
                    new FloatLabels($(this)[0], {
                        prefix: 'fl-',
                        prioritize: 'label',
                        transform: 'input'
                    });
                });
                // Show / hide filter panel for small to medium screen.
                $this.find('.sidebar-inner-title').click(function (event) {
                    event.preventDefault();
                    $sidebar.toggleClass('is-active');
                    $body.toggleClass('is-fixed');
                });
                $this.find('.facet-item a.is-active').each(function () {
                    $this = $(this);
                    $resetButton.show();
                    $this.closest('.accordion-item').addClass('is-active');
                    $this.closest('.accordion-content').show();
                });
                // Recalculate columns height when accordion items expand or collapse.
                $this.find('.accordion').on('down.zf.accordion up.zf.accordion', function () {
                    Foundation.reInit($('.cpl-layout-shop-sidebar-left'));
                });
            });
            // Hide title when no results.
            const $noResults = $('.view-shop-products .no-results', context);
            $noResults.once('hide-title-no-results').each(function () {
                $('.view-shop-products .no-results').closest('.views-element-container').find('.block-title').first().hide();
            });
            // Re-initiate layout equalizers on accordion menu click
            const $shopSidebar = $('.cpl-layout-shop-sidebar-left .sidebar-inner', context);
            $shopSidebar.once('shop-sidebar').each(function () {
                const $this = $(this);
                $this.find('[data-accordion]').each(function () {
                    $(this).on('up.zf.accordion down.zf.accordion', function () {
                        Foundation.reInit($('[data-equalizer]'));
                    });
                });
            });
        }
    };
    Drupal.behaviors['cplBaseCommerceTabToAccordion'] = {
        attach: function (context, settings) {
            const $responsiveTabs = $('.product-tabs .responsive-tabs', context);
            const $productPage = $('.cpl-product-page', context);
            $responsiveTabs.once('tab-to-accordion').each(function () {
                const $this = $(this);
                const $togglType = $this.find('.toggleType');
                const $tabWrap = $this.find('.tab-wrap');
                const accordionOnly = $productPage.hasClass('cpl-product-page-style-3') || $productPage.hasClass('cpl-product-page-style-4');
                const transformTabs = () => {
                    if ($(window).width() < 640) {
                        makeAccordion();
                    } else {
                        makeVerticalTabs();
                    }
                };
                function makeAccordion() {
                    if ($this.hasClass('tabs-content')) {
                        $tabWrap.css('display', 'none');
                        $this.removeClass('tabs-content');
                        $this.addClass('accordion');
                        $togglType.addClass('accordion-item');
                        $tabWrap.addClass('accordion-content');
                        $tabWrap.removeClass('tabs-panel');
                        $this.attr('data-accordion');
                        $this.find('.toggleType.is-active').children('.tab-wrap').css('display', 'block');
                        $this.find('.toggleType > .accordion-title').on('click', function (e) {
                            e.preventDefault();
                            $(this).children('tab-wrap').css('display', 'none');
                            $this.find('.toggleType.is-active').removeClass('is-active');
                            $(this).parent().addClass('is-active');
                            $(this).next('.accordion-content').slideToggle();
                            $this.find('.toggleType.is-active a').attr('aria-selected', 'true');
                        });
                    }
                }
                function makeVerticalTabs() {
                    if ($this.hasClass('accordion')) {
                        $this.removeAttr('data-accordion');
                        $this.removeClass('accordion');
                        $tabWrap.removeClass('accordion-content');
                        $tabWrap.addClass('tabs-panel');
                        $togglType.removeClass('accordion-item');
                        $this.addClass('tabs-content');
                        $tabWrap.css('display', '');
                    }
                }
                if (!accordionOnly) {
                    transformTabs();
                    $(window).resize(() => {
                        setTimeout(() => {
                            transformTabs();
                        }, 250);
                    });
                } else {
                    makeAccordion();
                }
            });
        }
    };
}(jQuery, Drupal));